import { api } from 'utility';
import { getMyRequestedApiKeyListUrl, getGenerateApiKeyUrl, getAllBusinessInfoUrl } from 'URLs';
export function getRequests(params) {
  return api.get(getMyRequestedApiKeyListUrl(), { params }).then((res) => res.data);
}
export function generateApiKeyApi(data, serviceId) {
  return api.get(getGenerateApiKeyUrl(serviceId), data).then((res) => res.data);
}
export function deleteApiKeyApi(params, requestId) {
  return api.delete(getGenerateApiKeyUrl(requestId), { params }).then((res) => res.data);
}
export function getBusinessList(obj) {
  const params = { offset: 0, size: 10, ...obj };
  return api.get(getAllBusinessInfoUrl(), { params }).then((res) => res.data);
}

export default {
  getRequests,
  generateApiKeyApi,
  deleteApiKeyApi,
  getBusinessList,
};
